import {
  StyledScrollSection,
  StyledSection,
} from '@components/layouts/Layouts';
import {
  ButtonNormalSecondarySmallCompact,
  DividerHorizontal,
  RowCenterBetween,
  TextHeading2,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';

import { usePublicationsAvailableListComposedGeolocation } from '@modules/publications/publications.store';
import { PublicationsAvailableNearbyList } from '@modules/publications/PublicationsAvailableNearbyList';

export const HomeNearbySection = () => {
  const { isLoading, isEmpty } =
    usePublicationsAvailableListComposedGeolocation();

  if (isLoading || isEmpty) {
    return null;
  }

  return (
    <>
      <StyledSection>
        <DividerHorizontal />

        <RowCenterBetween>
          <TextHeading2>Próximos a você</TextHeading2>

          <LinkWrapper href="/publications?is_nearby=true">
            <ButtonNormalSecondarySmallCompact>
              Ver todos
            </ButtonNormalSecondarySmallCompact>
          </LinkWrapper>
        </RowCenterBetween>
      </StyledSection>

      <StyledScrollSection>
        <PublicationsAvailableNearbyList />
      </StyledScrollSection>
    </>
  );
};
